import { useDispatch } from 'react-redux';
import { setOpenId, setIsActive } from 'automation-ui-canvas/actions/MenuBarActions';
export function useHelpSearchOption() {
  const dispatch = useDispatch();
  return {
    id: 'helpSearch',
    getLabel: () => '',
    shortcut: {
      control: true,
      key: 'K'
    },
    onClick: () => {
      dispatch(setOpenId({
        openId: 'help'
      }));
      dispatch(setIsActive({
        isActive: true
      }));
    }
  };
}